import React, {Component} from 'react';

import strings from 'strings';

import listen from 'assets/listen.png';

import './styles.scss';

import {no_test, nn_test, no_test_norming, nn_test_norming} from './assets';
import {stopAllSounds, createHowl, playHowl} from 'utils/playSound';

class Test extends Component {
	constructor(props) {
		super(props);
		const {ageGroup} = this.props;
		const isNormingActive = ageGroup === 6 || ageGroup === 7;

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = isNormingActive ? nn_test_norming : nn_test;
				break;
			case 'no':
				this.assets = isNormingActive ? no_test_norming : no_test;
				break;
			default:
				this.assets = no_test;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		clearTimeout(this.numbersTimer);
	}

	initializeAudio = () => {
		//Object.values(this.assets).forEach(audioEl => audioEl.load());

		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};
	startNewTask = (taskNumber) => {
		stopAllSounds(); //  add this
		clearTimeout(this.numbersTimer);

		this.playNumbers(['sound' + (Number(taskNumber) + 1)]);
	};

	playSound = (sound, callback) => {
		const src = this.assets[sound];
		if (!src) return;

		const howl = createHowl({
			src,
			onend: () => {
				if (callback) callback();
				howl.unload(); //  prevent memory leak
			},
		});

		playHowl(howl);
	};

	playNumbers = (soundArray) => {
		if (!soundArray.length) return;

		this.playSound(soundArray[0], () => {
			const newArr = soundArray.slice(1);

			if (newArr.length) {
				this.playNumbers(newArr);
			} else {
				this.props.startTimer();
			}
		});
	};

	render() {
		const timeExpired = this.props.stepData && this.props.stepData.timeExpired;
		if (timeExpired) {
			return (
				<div className="Spoonerism">
					<p>{strings.sp_waiting_for_next}</p>
				</div>
			);
		}
		return (
			<div className="Spoonerism">
				<img className="listen-image" src={listen} alt="" />
				<p>{strings.sp_instruction}</p>
			</div>
		);
	}
}

export default Test;
